import RouteTemplate from 'ember-route-template';
import { PageLoading } from 'embroil/components/loading';

export default RouteTemplate(
  <template>
  <PageLoading @message="Loading game reviews..." @subtitle="Finding the latest reviews and ratings for you" />
</template>
);
